import moment from 'moment';

export const getTimeDifference = (
  departTime: string,
  arrivalTime: string,
  arrivalDay: number,
  forShow = true,
): string | number => {
  const depDate = moment(departTime, 'HH:mm');
  const arrDate = moment(arrivalTime, 'HH:mm').add(arrivalDay, 'days');
  if (forShow) {
    const hours = arrDate.diff(depDate, 'hours');
    const dur = Math.trunc(arrDate.diff(depDate) / 1000 / 60 / 60);
    const dur2 = Math.round((arrDate.diff(depDate) / 1000 / 60 / 60 - dur) * 60);
    return `${hours ? `${dur}h` : ``} ${dur2}m`;
  }

  return arrDate.diff(depDate, 'ms');
};

export const getISODate = (date: moment.Moment | null, time: string, day = 0): string => {
  const [hours, minutes] = time.split(':');

  return moment(date)
    .add(day, 'day')
    .set({
      hour: parseInt(hours, 10),
      minute: parseInt(minutes, 10),
    })
    .toISOString();
};

export const returnDateDiff = (duration: string | any) => {
  const day = moment.duration(duration, 'd').days();
  const hour = moment.duration(duration, 'h').hours();
  const min = moment.duration(duration, 'm').minutes();
  return `${day * 24 + hour}h ${min}m`;
};

export const isValidDate = (value: string | null | undefined) => {
  if (!value)
    return false;

  const dateParts = value.split('/');

  const day = +dateParts[0];
  const month = +dateParts[1] - 1;
  const year = +dateParts[2];

  const date = new Date(year, month, day);

  return date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day;
};
